import { Component, OnInit, HostListener } from '@angular/core';
import { MdDialogRef } from '@angular/material';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { plainToClass } from 'class-transformer';
import { Observable } from 'rxjs/Observable';

import { FormErrors, isValidMailFormat } from 'app/shared/validators/generic-validators';
import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { unsavedFormCheck } from 'app/shared/validators/generic-validators';

import { ApplicationValue } from 'app/services/warmup/application-type.model';
import { Communication } from 'app/entities/details/contactinformation/communication.model';
import { ContactService } from 'app/entities/details/contactinformation/contact.service';


@Component({
  selector: 'addcontactinformation',
  templateUrl: './addcontactinformation.component.html',
  styleUrls: ['./addcontactinformation.component.css']
})
export class AddContactInformationComponent implements OnInit {

  addContactInformationForm: FormGroup;
  contactTypes: ApplicationValue[];
  action: string;
  entityId: number;
  entityType: string;
  selectedContact: Communication;
  savingContact = false;

  formErrors = {
    'contactValue': '',
  };

  validationMessages = {
    'contactValue': {
      'required': 'Required field value.',
      'invalidEmail': 'Invalid email format.',
    },
  };

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MdDialogRef<any>,
    private snackBarService: SnackBarService,
    private contactService: ContactService
  ) { }

  ngOnInit() {
    this.buildForm();
  }

  buildForm() {
    this.addContactInformationForm = this.formBuilder.group({
      contactType: ['', Validators.required],
      contactValue: ['', Validators.compose([
        Validators.required, isValidMailFormat
      ])],
    });
    this.updateForm();
    this.onValueChanged();
  }

  onValueChanged(data?: any) {
    if (!this.addContactInformationForm) {
      return;
    }
    FormErrors('addContactInformationForm', this);
  }

  changeContactType(selectedValue: number) {
    if (!selectedValue) {
      return;
    }

    var type = this.contactTypes.find(function (obj) {
      return obj.id == selectedValue;
    });

    if (type.name == 'Work email' || type.name == 'Private email') {
      this.addContactInformationForm.controls["contactValue"].clearValidators()
      this.addContactInformationForm.controls["contactValue"].setValidators(
        [Validators.compose([Validators.required, isValidMailFormat])]
      );
    } else {
      this.addContactInformationForm.controls["contactValue"].clearValidators()
      this.addContactInformationForm.controls["contactValue"].setValidators(
        [Validators.required]
      );
    }
    this.onValueChanged();
  }

  updateForm(): void {
    if (this.selectedContact) {
      this.addContactInformationForm.patchValue({
        contactType: this.selectedContact.type,
        contactValue: this.selectedContact.details,
      });
      this.changeContactType(this.selectedContact.type);
    }
  }

  onSubmit({ value, valid }): void {
    this.savingContact = true;
    if (this.action === 'Add') {
      const contact = new Communication();
      contact.entityId = this.entityId;
      contact.type = value.contactType;
      contact.details = value.contactValue;

      this.contactService.addContact(contact, this.entityType)
        .subscribe(
        success => {
          this.savingContact = false;
          if (success.flagResult) {
            this.dialogRef.close(success.arrResult);
          }
          this.callSnackBarService(success, this.action);
        },
        err => {
          this.savingContact = false;
          this.callSnackBarService(err, this.action);
        }
        );
    } else {
      this.selectedContact.details = value.contactValue;
      this.selectedContact.entityId = this.entityId;
      this.contactService.updateContact(this.selectedContact, this.entityType)
        .subscribe(
        success => {
          this.savingContact = false;
          if (success.flagResult) {
            this.dialogRef.close(success.arrResult);
          }
          this.callSnackBarService(success, this.action);
        },
        err => {
          this.savingContact = false;
          this.callSnackBarService(err, this.action);
        }
        );
    }
  }

  callSnackBarService(response: any, operation: string) {
    this.snackBarService.showStatus(response, operation === 'Add'
      && MessageService.CONTACT_ADDED_SUCCESS || MessageService.CONTACT_UPDATED_SUCCESS,
      MessageService.CONTACT_FAILURE);
  }

}



// WEBPACK FOOTER //
// ./src/app/entities/details/contactinformation/addcontactinformation/addcontactinformation.component.ts